import $api from "..";
import {AxiosResponse} from "axios";
import { IUnarchiveProjects } from "../common/api_interfaces/archive/IUnarchiveProjects";
import { ICardProject, IProjectMinimal } from "../common/api_interfaces/project/ICardProjectProject";
import { IProjectGeneralInfo } from "../common/api_interfaces/project/IProjectGeneralInfo";
import { IProjectProgressInfo } from "../common/api_interfaces/project/IProjectProgressInfo";
import { IProjectHistoryDisplay } from "../common/api_interfaces/history/IProjectHistoryDisplay";
import { IGetProjectHistoryDisplay } from "../common/api_interfaces/history/IGetProjectHistoryDisplay";
import { IProjectDeleteReq } from "../common/api_interfaces/project/IProjectDeleteReq";
import { ProjectSettings } from "../common/api_interfaces/project/ProjectSettings";
import { IChangeColumnStatusSetting } from "../common/api_interfaces/project/IChangeProjectSettingChangingStatus";
import { ITeamDisplay } from "../common/api_interfaces/project/ITeamDisplay";
import { IGetTeamDisplay } from "../common/api_interfaces/project/IGetTeamDisplay";
import { IProjectCreateReq } from "../common/api_interfaces/project/IProjectCreateReq";
import { IProjectEditReq } from "../common/api_interfaces/project/IProjectEditReq";

export default class ProjectService {

    async getProjectSettings(projectId: number): Promise<AxiosResponse<ProjectSettings>> {
        return $api.get<ProjectSettings>(`/Project/projectSettings?projectId=${projectId}`);
    }

    static async createProject(body: IProjectCreateReq): Promise<AxiosResponse<void>> {
        return $api.post<void>(`/project/add`, body);
    }

    static async getAllProject(includeSubprojects: boolean): Promise<AxiosResponse<ICardProject[]>> {
        return $api.get<ICardProject[]>(`/getAllProject?includeSubprojects=${includeSubprojects}`);
    }

    static async getArchiveProjects(): Promise<AxiosResponse<ICardProject[]>> {
        return $api.get<ICardProject[]>('/archive/list');
    }

    static async getProjectHistoryDisplayData(body: IGetProjectHistoryDisplay): Promise<AxiosResponse<IProjectHistoryDisplay[]>> {
        return $api.post<IProjectHistoryDisplay[]>(`Project/getProjectHistory`, body); //TODO fix endpoint
    }

    async getProjectTeamDisplayData(body: IGetTeamDisplay): Promise<AxiosResponse<ITeamDisplay>> {
        return $api.post<ITeamDisplay>(`Project/getTeamMembers`, body);
    }

    static async getProjectProgressData(projectId: number): Promise<AxiosResponse<IProjectProgressInfo>> {
        return $api.get<IProjectProgressInfo>(`Project/getStatisticData?projectId=${projectId}`);
    }

    static async getProjectGeneralInfo(projectId: number): Promise<AxiosResponse<IProjectGeneralInfo>> {
        return $api.get<IProjectGeneralInfo>(`Project/projectGeneralInfo?projectId=${projectId}`);
    }

    static async editProject(body: IProjectEditReq): Promise<AxiosResponse<void>> {
        return $api.post<void>(`/project/edit`, body);
    }

    static async deleteProject(body: IProjectDeleteReq): Promise<AxiosResponse<void>> {
        return $api.post<void>(`/Project/deleteProject`, body);
    }

    static async archiveProject(projectId: number): Promise<AxiosResponse<void>> {
        return $api.get<void>(`/project/archive?id=${projectId}`);
    }

    static async unarchiveProjects(body: IUnarchiveProjects): Promise<AxiosResponse<void>> {
        return $api.post<void>(`/project/unarchive`, body);
    }

    async getAllowedProjects(taskId: number): Promise<AxiosResponse<IProjectMinimal[]>> {
        return $api.get<IProjectMinimal[]>(`/Project/getAllowed?taskId=${taskId}`);
    }

    async changProjectSettingChangingStatus(body: IChangeColumnStatusSetting): Promise<AxiosResponse<void>> {
        return $api.post<void>(`/Project/changeColumnStatusSetting`, body)
    }
}